export default class ElementIdManager {
    public static nextId(): string {
        return `el-${++ElementIdManager.lastId}`;
    }

    private static lastId: number = 0;
}
